import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const transformEntitiesFn = json => ({
    id:   json.id,
    name: json.name
});

const name = 'subscriptions',
    exports = storeModuleFactory({
        name,
        endpoint: endpoints.subscriptions.endpoint,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        transformEntitiesFn
    });

exports.transformEntitiesFn = transformEntitiesFn;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/subscriptions.js